import { render, staticRenderFns } from "./changeBind.vue?vue&type=template&id=045d560d&scoped=true&"
import script from "./changeBind.vue?vue&type=script&lang=js&"
export * from "./changeBind.vue?vue&type=script&lang=js&"
import style0 from "./changeBind.vue?vue&type=style&index=0&id=045d560d&lang=less&scoped=true&"
import style1 from "./changeBind.vue?vue&type=style&index=1&id=045d560d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d560d",
  null
  
)

export default component.exports